// src/context/PanelsContext.js
//
// Panel konumları + stack yükseklikleri PAFTA BAZINDA tutulur. Her paftanın
// kendi panel yerleşimi vardır; pafta değişince paneller o paftaya ait konuma
// (sürüklenmişse kayıtlı, değilse stack) geri döner. (Paneller tek DOM instance
// olduğundan konum el.style ile yönetilir; restore panellerin activeTabId
// effect'inde yapılır — bkz. usePanels().activeTabId.)

import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

const PanelsContext = createContext();

const PANEL_ORDER = ['TestPanel', 'PanoDetayPanel', 'BaslikPanel', 'KabloBacasiPanel'];
const BASE_TOP = 115;
const COLLAPSED_HEIGHT = 40;

const EMPTY = {};
const DEFAULT_HEIGHTS = (() => { const h = {}; PANEL_ORDER.forEach(n => { h[n] = COLLAPSED_HEIGHT; }); return h; })();

export const PanelsProvider = ({ children }) => {
  const activeTabId = useSelector(s => s.projectTabs?.activeTabId) || '_default';
  const [panelsByTab, setPanelsByTab] = useState({});
  const [heightsByTab, setHeightsByTab] = useState({});

  const registerPanel = useCallback((name, info) => {
    setPanelsByTab(prev => {
      const tab = prev[activeTabId] || {};
      // Zaten kayıtlıysa (ör. sürüklenmiş) ezmemek için sadece yoksa yaz.
      if (tab[name]) return prev;
      return { ...prev, [activeTabId]: { ...tab, [name]: info } };
    });
  }, [activeTabId]);

  const updatePanelPosition = useCallback((name, pos) => {
    setPanelsByTab(prev => {
      const tab = prev[activeTabId] || {};
      return { ...prev, [activeTabId]: { ...tab, [name]: { ...tab[name], ...pos } } };
    });
  }, [activeTabId]);

  const setPanelHeight = useCallback((name, height) => {
    setHeightsByTab(prev => {
      const tab = prev[activeTabId] || DEFAULT_HEIGHTS;
      if (tab[name] === height) return prev;
      return { ...prev, [activeTabId]: { ...tab, [name]: height } };
    });
  }, [activeTabId]);

  const panels = panelsByTab[activeTabId] || EMPTY;
  const panelHeights = heightsByTab[activeTabId] || DEFAULT_HEIGHTS;

  // SABİT konum — her panelin varsayılan yeri diğer panellerin AÇIK/KAPALI
  // durumundan BAĞIMSIZ (BASE_TOP + idx * COLLAPSED_HEIGHT). Böylece bir panel
  // açılıp büyüyünce alttaki paneller KAYMAZ (kullanıcı isteği).
  const getStackTop = useCallback((name) => {
    const idx = PANEL_ORDER.indexOf(name);
    if (idx === -1) return BASE_TOP;
    return BASE_TOP + idx * COLLAPSED_HEIGHT;
  }, []);

  const value = useMemo(() => ({
    activeTabId, panels, registerPanel, updatePanelPosition,
    setPanelHeight, getStackTop, panelHeights,
  }), [activeTabId, panels, registerPanel, updatePanelPosition, setPanelHeight, getStackTop, panelHeights]);

  return (
    <PanelsContext.Provider value={value}>
      {children}
    </PanelsContext.Provider>
  );
};

export const usePanels = () => useContext(PanelsContext);
